// URLs (Alphabetical)
import { EXTERNAL_LINKS } from './external-links';

export const API_BASE_URL = process.env.API_BASE_URL || 'http://localhost:3001';
export const DOCUMENTUM_URL =
  process.env.DOCUMENTUM_URL || 'http://localhost:5522';
export const FLAGS_KEY =
  process.env.FLAGS_KEY || 'stale_aardvark_tarnish_regulate_nash';
export const FLAGS_URL = process.env.FLAGS_URL || 'http://localhost:6446';
export const AUTH_URL = process.env.AUTH_URL || 'http://localhost:3000';
export const IMAGE_URL =
  process.env.IMAGE_URL || 'http://localhost:3004/images';
export const LOGISTICS_URL =
  process.env.LOGISTICS_URL || 'http://localhost:27551';
export const WORKER_URL = process.env.WORKER_URL || 'http://localhost:3004';
export const METERAGE_URL = process.env.METERAGE_URL || 'http://localhost:8010';
export const NETSUITE_URL =
  process.env.NETSUITE_URL || 'http://localhost:12000';
export const NO_IMAGE_URL =
  'https://ordermentum-res.cloudinary.com/image/upload/v1536104306/c5fqm3xqizhhmllpp6sx.png';
export const VENUE_INSIGHTS_URL =
  process.env.VENUE_INSIGHTS_URL || 'http://localhost:8007';
export const INSIGHTS_URL = process.env.INSIGHTS_URL || 'http://localhost:7777';
export const NOTIFICATIONS_URL =
  process.env.NOTIFICATIONS_URL || 'http://localhost:32308';
export const PAYMENTS_URL = process.env.PAYMENTS_URL || 'http://localhost:4000';
export const REWARDS_URL = process.env.REWARDS_URL || 'http://localhost:4431';

// THIRD PARTY
export const SENTRY_DSN = process.env.SENTRY_DSN || '';
export const SENTRY_ENVIRONMENT = process.env.SENTRY_ENVIRONMENT || 'sandbox';
export const SENTRY_RELEASE = process.env.SENTRY_RELEASE ?? undefined;
export const SENTRY_APPLICATION_KEY = process.env.SENTRY_APPLICATION_KEY || '';

// Other (Alphabetical)
export const AUS_STATES = ['NSW', 'VIC', 'QLD', 'ACT', 'SA', 'WA', 'NT', 'TAS'];
export const AUS_STATES_OPTIONS = [
  { display: 'New South Wales', value: 'NSW' },
  { display: 'Victoria', value: 'VIC' },
  { display: 'Queensland', value: 'QLD' },
  { display: 'Australian Capital Territory', value: 'ACT' },
  { display: 'South Australia', value: 'SA' },
  { display: 'Western Australia', value: 'WA' },
  { display: 'Northern Terrority', value: 'NT' },
  { display: 'Tasmania', value: 'TAS' },
];
export const AUS_STATES_DISPLAY_TO_VALUE_MAP = {
  'New South Wales': 'NSW',
  Victoria: 'VIC',
  Queensland: 'QLD',
  'Australian Capital Territory': 'ACT',
  'South Australia': 'SA',
  'Western Australia': 'WA',
  Tasmania: 'TAS',
};
export const BROWSER_TZ =
  (Intl && Intl.DateTimeFormat().resolvedOptions().timeZone) ||
  'Australia/Sydney';

export const COUNTRIES = {
  AU: 'Australia',
};

export const COUNTRIES_OPTIONS = [
  'Australia',
  'New Zealand',
  'United States',
  'United Kingdom',
  'Canada',
  'Singapore',
  'Malaysia',
  'Hong Kong',
  'China',
  'Japan',
  'India',
  'Indonesia',
  'Philippines',
  'Thailand',
  'Vietnam',
  'South Korea',
  'France',
  'Germany',
  'Italy',
  'Spain',
  'Netherlands',
  'Belgium',
  'Switzerland',
  'Austria',
  'Sweden',
  'Norway',
  'Denmark',
  'Finland',
  'Ireland',
  'Poland',
  'Portugal',
  'Greece',
  'Czech Republic',
  'Hungary',
  'Romania',
  'Brazil',
  'Mexico',
  'Argentina',
  'Chile',
  'Colombia',
  'Peru',
  'South Africa',
  'Egypt',
  'Nigeria',
  'Kenya',
  'United Arab Emirates',
  'Saudi Arabia',
  'Israel',
  'Turkey',
  'Russia',
  'Ukraine',
] as const;

export const DAYS_SHORT = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
export const DATE_TIME = 'DD/MM/YY [at] h:mm a';
export const DAY_DATE_TIME = 'ddd DD/MM/YY [at] h:mm a';
export const DAY_ORD_DATE = 'ddd Do MMM YYYY';
export const DAY_DATE_SHORT_TIME = 'ddd DD MMM, h:mm a';
export const DAY_DATE_TIME_SHORT = 'ddd Do MMM YYYY h:mm a';
export const EXPERIMENT_INTERVALS = ['total', 'day', 'week', 'month', 'year'];
export const FLAGS_TIMEOUT: number | string = process.env.FLAGS_TIMEOUT || 1000;
export const NOTIFICATION_DELAY = 3000;
export const TOTAL_SETUP_STEPS = 5;
export const TEMPLATE_ORDER_TYPES = ['template', 'favourite'];
// PAYMENTS
export const MAX_CARD_NUMBER_LENGTH = 16;
export const MAX_CVV_LENGTH = 4;
export const MAX_EXPIRY_DATE_LENGTH = 5;
export const EXPIRY_MONTH_POSITION = 2;
export const EXPIRY_YEAR_POSITION = 3;
export const CART_URL = process.env.CART_URL || 'http://localhost:8002';
export const XERO_URL = process.env.XERO_URL || 'http://localhost:4320';
export const INTEGRATOR_URL =
  process.env.INTEGRATOR_URL || 'http://localhost:8004';
export const STOCK_URL = process.env.STOCK_URL || 'http://localhost:8006';
export const SPREEDLY_ENVIRONMENT_KEY =
  process.env.SPREEDLY_ENVIRONMENT_KEY || '';
export const STRIPE_PUBLISHABLE_KEY = process.env.STRIPE_PUBLISHABLE_KEY || '';
export const STRIPE_PRICING_TABLE_ID =
  process.env.STRIPE_PRICING_TABLE_ID || '';
export const INVOICES_EMAIL_DOMAIN =
  process.env.INVOICES_EMAIL_DOMAIN || '@invoices.ordermentum-sandbox.com';

export const DEBOUNCE_DELAY = 500;

export const NO_DATA = '--';

export default {
  EXTERNAL_LINKS,
  AUS_STATES,
  AUS_STATES_OPTIONS,
  AUS_STATES_DISPLAY_TO_VALUE_MAP,
  DAYS_SHORT,
  API_BASE_URL,
  FLAGS_KEY,
  FLAGS_URL,
  IMAGE_URL,
  NETSUITE_URL,
  NO_IMAGE_URL,
  AUTH_URL,
  CART_URL,
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  SENTRY_RELEASE,
  BROWSER_TZ,
  COUNTRIES,
  COUNTRIES_OPTIONS,
  DATE_TIME,
  DAY_DATE_TIME,
  DAY_ORD_DATE,
  EXPERIMENT_INTERVALS,
  FLAGS_TIMEOUT,
  NOTIFICATION_DELAY,
  MAX_CARD_NUMBER_LENGTH,
  MAX_CVV_LENGTH,
  MAX_EXPIRY_DATE_LENGTH,
  EXPIRY_MONTH_POSITION,
  EXPIRY_YEAR_POSITION,
  TOTAL_SETUP_STEPS,
  XERO_URL,
  INTEGRATOR_URL,
  SPREEDLY_ENVIRONMENT_KEY,
  STRIPE_PUBLISHABLE_KEY,
  STRIPE_PRICING_TABLE_ID,
};

export * from './keys';
export * from './keystrokes';
export * from './redux';
export * from './ui';
export * from './rewards';
export * from './external-links';
